import ArticleJobs from "./ArticleJobs";

export default class ResidentBusinessGuides extends ArticleJobs {
  bindSponsorshipVisibilityToggle() {
    // RBG
    N2.bindHandler("change", "[type=radio][name='resident_business_guide[placement_publication_ids][]']", (evt) => { // eslint-disable-line
      const $target = $(evt.target);
      $(".selectize-dropdown.js-sponsorship-select").addClass("hidden");
      $(".selectize-control.js-sponsorship-select").addClass("hidden");
      if (this.params.pubIdsWithSponsors.includes($target.val())) {
        this.handleSelectedPub($target);
        this.handleSelectedSponsor($target);
      }
    });

    // TODO: can this be factored out from ArticleJobs?
    N2.bindHandler("change", ".js-sponsorship-select", (evt) => { // eslint-disable-line
      const $ele = $(evt.target);
      const shouldDestroy = ["No Sponsorship"].includes($ele.val());
      const $destroy = $(".js-destroy", $ele.closest(".hidden-sponsorship-select"));
      $destroy.val(shouldDestroy);
    });
  }
}
